/* eslint-disable */
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import EntriesContextPropTypes from '../../Contexts/Entries/Entries.props';
import AuthEntityPropTypes from '../../Services/Auth/Auth.service.props';
import I18nEntityPropTypes from '../../Services/I18n/I18n.service.props';
import sidebarActionCreators from '../../State/Store/Sidebar/Sidebar.actions';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';
import propsActionCreatorsToPropTypes from '../../Support/Props/ActionCreatorKey/PropsActionCreatorsToPropTypes.support';

const NavbarPropTypes = {
  /**
   * The actions to be used by this component
   */
  actions: PropTypes.shape({
    ...propsActionCreatorsToPropTypes(sidebarActionCreators),
  }).isRequired,

  /**
   * The current `auth` or `null`
   */
  auth: AuthEntityPropTypes.auth,

  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The current `entry`
   */
  entry: EntriesContextPropTypes.entry.isRequired,

  /**
   * The i18n key to be looked up and then displayed in the <Toolbar />
   */
  heading: PropTypes.string,

  /**
   * The optional data to be supplied to the i18n `heading`
   */
  headingData: PropTypes.object,

  /**
   * Whether or not to hide the logo
   */
  hideLogo: PropTypes.bool,

  /**
   * Whether or not to hide the menu icon
   */
  hideMenuIcon: PropTypes.bool,

  /**
   * Whether or not to hide the user menu
   */
  hideUserMenu: PropTypes.bool,

  /**
   * The `history` props from `react-router`
   */
  history: ReactRouterPropTypes.history.isRequired,

  /**
   * The current `locale`
   */
  locale: I18nEntityPropTypes.locale.isRequired,

  /**
   * The `location` props from `react-router`
   */
  location: ReactRouterPropTypes.location.isRequired,

  /**
   * The `match` props from `react-router`
   */
  match: ReactRouterPropTypes.match.isRequired,

  /**
   * The extensions for the Navbar
   */
  renderExtensions: PropTypes.node,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default NavbarPropTypes;
